// extracted by mini-css-extract-plugin
module.exports = {"root":"Textarea_root__2m3jR","error":"Textarea_error__3a2kf","readonly":"Textarea_readonly__mAylM","disabled":"Textarea_disabled__1hj0S"};